<template lang="html">
  <header id="header">
    <div class="header-menu">
      <b-navbar toggleable="md" type="light" variant="light">
        <div class="container med-container">
          <b-navbar-brand to="/">
            <img src="public/images/logo.png">
          </b-navbar-brand>

          <!-- <b-navbar-toggle target="nav-collapse"><i class="fa-light fa-bars"></i></b-navbar-toggle> -->

          <div class="d-inline d-md-none">
            <router-link class="btn btn-s1 bg-1 btn-job" to="/registro" v-if="$route.name != 'registerPage'">Trabaja como operador</router-link>
            <router-link class="btn btn-s1 outline-1" to="/" v-if="$route.name == 'registerPage'">Regresar al Inicio</router-link>
          </div>

          <b-collapse id="nav-collapse" is-nav>
            <!-- <b-navbar-nav class="mx-auto">
              <b-nav-item class="simple-item" to="/">xxxxxxx</b-nav-item>
              <b-nav-item class="simple-item" to="/">xxxxxxx</b-nav-item>
            </b-navbar-nav> -->

            <b-navbar-nav class="ml-auto navbar-btn">
              <div class="box-networks">
                <a target="_blank" href="https://www.facebook.com/marquezexpressinc/"><i class="fa-brands fa-facebook-f"></i></a>
                <a target="_blank" href="https://www.instagram.com/marquezexpress/"><i class="fa-brands fa-instagram"></i></a>
              </div>
              <router-link class="btn btn-s1 bg-1" to="/registro" v-if="$route.name != 'registerPage'">Trabaja como operador de unidad</router-link>
              <router-link class="btn btn-s1 outline-1" to="/" v-if="$route.name == 'registerPage'">Regresar al Inicio</router-link>
            </b-navbar-nav>
          </b-collapse>
        </div>
      </b-navbar>

      	<loader style="position: fixed;z-index: 10000;" v-if="$root.isLoading == true" object="#29166e" color1="#ffffff" color2="#29166e" size="5" speed="2" bg="#343a40" objectbg="#999793" opacity="80" disableScrolling="false" name="circular"></loader>

    </div>
  </header>
</template>

<script>
export default {
}
</script>
